import _wallet from "./wallet";
import _waitInjected from "./helpers/waitInjected";
import _proxyMethods from "./helpers/proxyMethods";
import _nep from "./helpers/nep0314";
import _actions from "./helpers/actions";
import _types from "./helpers/types";
import _utils from "./helpers/utils";
import _HereKeyStore from "./storage/HereKeyStore";
import _JSONStorage from "./storage/JSONStorage";
import _HereStrategy from "./strategies/HereStrategy";
import _InjectedStrategy from "./strategies/InjectedStrategy";
import _TelegramAppStrategy from "./strategies/TelegramAppStrategy";
import _WidgetStrategy from "./strategies/WidgetStrategy";
import _WindowStrategy from "./strategies/WindowStrategy";
import _types2 from "./types";
var exports = {};
var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = exports && exports.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HereWallet = void 0;
var wallet_1 = _wallet;
Object.defineProperty(exports, "HereWallet", {
  enumerable: true,
  get: function () {
    return wallet_1.HereWallet;
  }
});
__exportStar(_waitInjected, exports);
__exportStar(_proxyMethods, exports);
__exportStar(_nep, exports);
__exportStar(_actions, exports);
__exportStar(_types, exports);
__exportStar(_utils, exports);
__exportStar(_HereKeyStore, exports);
__exportStar(_JSONStorage, exports);
__exportStar(_HereStrategy, exports);
__exportStar(_InjectedStrategy, exports);
__exportStar(_TelegramAppStrategy, exports);
__exportStar(_WidgetStrategy, exports);
__exportStar(_WindowStrategy, exports);
__exportStar(_types2, exports);
//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule,
  HereWallet = exports.HereWallet,
  waitInjectedHereWallet = exports.waitInjectedHereWallet,
  createRequest = exports.createRequest,
  computeRequestId = exports.computeRequestId,
  deleteRequest = exports.deleteRequest,
  getResponse = exports.getResponse,
  getRequest = exports.getRequest,
  proxyApi = exports.proxyApi,
  verifySignature = exports.verifySignature,
  authPayloadSchema = exports.authPayloadSchema,
  AuthPayload = exports.AuthPayload,
  createAction = exports.createAction,
  parseArgs = exports.parseArgs,
  isValidAccessKey = exports.isValidAccessKey,
  internalThrow = exports.internalThrow,
  getPublicKeys = exports.getPublicKeys,
  serializeActions = exports.serializeActions,
  isMobile = exports.isMobile,
  getDeviceId = exports.getDeviceId,
  HereKeyStore = exports.HereKeyStore,
  StateStorage = exports.StateStorage,
  HereStrategy = exports.HereStrategy,
  InjectedStrategy = exports.InjectedStrategy,
  TelegramAppStrategy = exports.TelegramAppStrategy,
  WidgetStrategy = exports.WidgetStrategy,
  defaultUrl = exports.defaultUrl,
  WindowStrategy = exports.WindowStrategy,
  HereProviderError = exports.HereProviderError,
  HereProviderStatus = exports.HereProviderStatus;